import { Amplify } from 'aws-amplify'
import {
  fetchAuthSession,
  fetchUserAttributes,
  signIn,
  signOut,
  confirmSignIn,
  updateUserAttributes,
  signInWithRedirect
} from 'aws-amplify/auth'
import { Hub } from 'aws-amplify/utils'

export default defineNuxtPlugin({
  name: 'AmplifyAPIs',
  enforce: 'pre',

  setup () {
    const {
      public: {
        NUXT_COGNITO_POOL_ID,
        NUXT_COGNITO_CLIENT_ID,
        NUXT_COGNITO_DOMAIN,
        NUXT_COGNITO_IDENTITY_POOL_ID,
        NUXT_S3_BUCKET
      }
    } = useRuntimeConfig()

    Hub.listen('auth', async ({ payload }) => {
      const { $notificationHelper } = useNuxtApp()

      switch (payload.event) {
        case 'signInWithRedirect':
          if (typeof $notificationHelper === 'function') {
            $notificationHelper({ title: 'Success', type: 'success', message: 'Logged in successfully' })
          }
          break
        case 'signInWithRedirect_failure':
          if (typeof $notificationHelper === 'function') {
            $notificationHelper({ title: 'Error', message: 'Sign in process failed. Try again or contact support.' })
          }
          break
      }

      const redirectUrl = localStorage.getItem('redirectAfterLoginURL')
      navigateTo(redirectUrl || '/')
    })

    // This configures Amplify on the client side of your Nuxt app
    Amplify.configure({
      Auth: {
        Cognito: {
          identityPoolId: NUXT_COGNITO_IDENTITY_POOL_ID,
          userPoolClientId: NUXT_COGNITO_CLIENT_ID,
          userPoolId: NUXT_COGNITO_POOL_ID,
          allowGuestAccess: true,
          loginWith: {
            oauth: {
              redirectSignIn: [window.location.origin],
              redirectSignOut: [window.location.origin],
              domain: NUXT_COGNITO_DOMAIN,
              scopes: ['email', 'openid', 'phone', 'profile', 'aws.cognito.signin.user.admin'],
              responseType: 'code',
              providers: ['Apple', 'Google']
            }
          }
        }
      },
      Storage: {
        S3: {
          bucket: NUXT_S3_BUCKET,
          region: 'me-south-1'
        }
      }
    }, { ssr: true })

    return {
      provide: {
        // You can add the Amplify APIs that you will use on the client side
        // of your Nuxt app here.
        //
        // You can call the API by via the composable `useNuxtApp()`. For example:
        // `useNuxtApp().$Amplify.Auth.fetchAuthSession()`
        Amplify: {
          Auth: {
            fetchAuthSession,
            fetchUserAttributes,
            signIn,
            signOut,
            confirmSignIn,
            updateUserAttributes,
            signInWithRedirect
          }
        }
      }
    }
  }
})
